<template>
    <div class="login">
        <div class="center-box">
            <img alt="" class="logo" src="@/assets/images/logintitle.png">
            <div class="form-content">
                <div class="form-box">
                    <div class="form-title">用户登录</div>
                    <div class="tab-box">
                        <b class="active">账号密码登录</b>
                    </div>
                    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="0">
                        <el-form-item prop="name">
                            <div class="input-item">
                                <img alt="" src="@/assets/images/zhanghaoicon.png">
                                <el-input v-model="ruleForm.name" autocomplete="off" class="input" placeholder="账号" type="text"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="pass">
                            <div class="input-item">
                                <img alt="" src="@/assets/images/mimaicon.png">
                                <el-input v-model="ruleForm.pass" :type="showPass ? 'text' : 'password'" autocomplete="off" class="input" placeholder="密码"></el-input>
                                <i :class="showPass ? 'icon-mimakejian' : 'icon-mimabukejian'" class="iconfont" @click="showPass = !showPass"></i>
                            </div>
                        </el-form-item>
                        <el-form-item prop="checked">
                            <div class="xieyi">
                                <el-checkbox v-model="ruleForm.checked" class="chekbox"><p>我已阅读并同意服务协议、信息保护政策</p>
                                </el-checkbox>
                            </div>
                        </el-form-item>
                        <el-form-item class="radio-box">
                            <el-radio-group v-model="ruleForm.type">
                                <el-radio :label="1">教培机构</el-radio>
                                <el-radio :label="2">联盟/主管部门</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button v-loading="loading" class="btn" type="primary" @click="submitForm('ruleForm')">
                                登录
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {login} from '@/api/index'

export default {
    name: "login",
    data() {
        return {
            showPass: false,
            loading: false,
            ruleForm: {
                name: '',
                pass: '',
                checked: false,
                type: 1,
            },
            rules: {
                name: [
                    {required: true, message: '请输入账号', trigger: 'blur'}
                ],
                pass: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ],
                checked: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请阅读并同意'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            }
        }
    },
    components: {},
    computed: {
        token() {
            return this.$store.state.token
        },
    },
    mounted() {

    },
    created() {

    },

    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login()
                } else {
                    return false;
                }
            });
        },
        async login() {
            this.loading = true
            let _data = await login(
                this.ruleForm.name,
                this.ruleForm.pass,
                this.ruleForm.type
            )
            this.loading = false
            if (_data.status == 200) {
                this.$message.success(_data.msg)
                this.$store.state.token = _data.data.token.token
                this.$store.state.user = _data.data
                _data.data.token.type == 1 ? this.$router.replace('/home') : this.$router.replace('/admin')
            } else {
                this.$message.error(_data.msg)
            }

        }
    },
    filters: {},
    watch: {}
}
</script>

<style lang="scss" scoped>
/deep/ {
    .el-input__inner {
        height: 100%;
        border: none;
        background-color: transparent;
        padding: 0;
    }

    .el-checkbox__inner {
        width: 16px;
        height: 16px;
    }

    .el-checkbox__inner::after {
        height: 8px;
        left: 5px;
    }

    .el-radio__label {
        font-size: 20px;
        color: #64676d;
    }

    .el-radio__inner {
        width: 20px;
        height: 20px;
    }

    .el-radio__inner::after {
        width: 6px;
        height: 6px;
        background: #2791ff;
    }

    //.el-radio__input.is-checked .el-radio__inner::after {
    //  transform: translate(-47%, -53%) scale(1);
    //}
    .el-radio__input.is-checked .el-radio__inner {
        border-color: #0089ff;
        background: #ffffff;
    }

    .el-radio__input.is-checked + .el-radio__label {
        color: #64676d;
    }

    .el-radio {
        margin: 0 40px;
    }
}

.login {
    width: 100%;
    min-height: 100vh;
    background: url("../../assets/images/loginbgc.png") no-repeat center center;
    padding: 70px;
    display: flex;
    justify-content: center;
    align-items: center;

    .center-box {
        max-width: 1700px;
        width: 100%;
        margin: 0 auto;

        .logo {
            display: block;
        }

        .form-content {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-top: 30px;

            .form-box {
                width: 660px;
                height: 820px;
                background-image: linear-gradient(0deg,
                    #ffffff 75%,
                    #c2e0ff 100%);
                border-radius: 20px;
                border: solid 1px #ffffff;
                padding: 60px;

                .btn {
                    width: 100%;
                    height: 80px;
                    font-size: 20px;
                    border-radius: 40px;
                    margin-top: 30px;
                }

                .demo-ruleForm {
                    width: 100%;
                    padding: 30px 0;

                    .radio-box {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                    }

                    .xieyi {
                        width: 100%;

                        .chekbox {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                        }

                        p {
                            font-size: 16px;
                            color: #64676d;
                        }
                    }

                    .input-item {
                        height: 80px;
                        background-color: #f0f2f6;
                        border-radius: 10px;
                        width: 100%;
                        margin-top: 10px;
                        padding: 0 25px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        .iconfont {
                            font-size: 30px;
                            color: #999999;
                            margin-left: 30px;
                            cursor: pointer;
                        }

                        .input {
                            flex: 1;
                            height: 78px;
                            font-size: 18px;
                            color: #333333;
                        }

                        img {
                            margin-right: 20px;
                        }
                    }
                }

                .tab-box {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    padding-top: 50px;

                    b {
                        width: max-content;
                        margin-right: 30px;
                        font-size: 20px;
                        color: #16181d;
                        height: 46px;
                        line-height: 46px;

                        &.active {
                            font-weight: bold;
                            position: relative;
                        }

                        &.active:after {
                            content: "";
                            position: absolute;
                            width: 100%;
                            height: 4px;
                            background-color: #2791ff;
                            bottom: 0;
                            left: 0;
                            border-radius: 2px;
                        }
                    }
                }

                .form-title {
                    width: 100%;
                    text-align: center;
                    font-size: 34px;
                    font-weight: bold;
                    color: #16181d;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>
